export interface ToastOptions {
  message: string
  duration?: number
  variant?: 'default' | 'success' | 'error'
}

let container: HTMLElement | null = null

function getContainer(): HTMLElement {
  if (!container) {
    container = document.createElement('div')
    container.className = 'sn-toast-container'
    container.setAttribute('role', 'status')
    container.setAttribute('aria-live', 'polite')
    document.body.appendChild(container)
  }
  return container
}

/**
 * Shows a toast. Slide-in direction is controlled entirely via CSS
 * logical properties (Section 12.2) so it mirrors correctly in RTL
 * without any JS branching here.
 */
export function toast(options: ToastOptions): void {
  const el = document.createElement('div')
  el.className = `sn-toast sn-toast--${options.variant ?? 'default'}`
  el.textContent = options.message

  const host = getContainer()
  host.appendChild(el)

  requestAnimationFrame(() => el.classList.add('sn-toast--visible'))

  const duration = options.duration ?? 3000
  setTimeout(() => {
    el.classList.remove('sn-toast--visible')
    el.addEventListener('transitionend', () => el.remove(), { once: true })
  }, duration)
}
